import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-chatbot',
  templateUrl: './faq-chatbot.component.html',
  styleUrls: ['./faq-chatbot.component.css']
})
export class FaqChatbotComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
